<template>
    <div class="text-center">
        <v-modal-contents ref="modal_contents_agree">

            <template v-slot:close>
                <!--        убираем close-->
                <div></div>
            </template>

            <template v-slot:title>

                <div class="terms_of_use__title mt-30 pl-3 ">
                    <div class="h2_title">Условия использования персональных данных</div>

                </div>

            </template>
            <template v-slot:content>
                <div class="terms_of_use mt-30 ">
                    <div v-html="terms"></div>
                    <div class="mt-30">
                        <button class="px-30 btn-red "
                                @click="$refs.modal_contents_agree.modal_open()">
                            Прочитал
                        </button>

                    </div>
                </div>
            </template>
        </v-modal-contents>

        <v-dialog content-class="dialog_mail dialog_custom" v-model="dialog" width="516" relative persistent>
            <v-card>
                <v-card-text>
                    <v-form ref="form" @submit.prevent="" action="#" class="" v-model="valid" lazy-validation>
                        <section class="call">
                            <div class="call__header">
                                <h2 class="call__title">
                                    Написать письмо
                                </h2>

                                <button class="call__close" @click="dialog = false">
                                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                                d="M17.9991 15.8801L25.4241 8.45508L27.5451 10.5761L20.1201 18.0011L27.5451 25.4261L25.4241 27.5471L17.9991 20.1221L10.5741 27.5471L8.45312 25.4261L15.8781 18.0011L8.45312 10.5761L10.5741 8.45508L17.9991 15.8801Z"
                                                fill="#52525B"/>
                                    </svg>
                                </button>
                            </div>
                            <div class="call__inner">
                                <div class="call__form">
                                    <label for="name" class="call__label">
                                        <v-text-field
                                                v-model="name"
                                                :rules="nameRulesRu"
                                                required
                                                id="name"
                                                class="call__input"
                                        >
                                            <template v-slot:label>
                                                ФИО *
                                            </template>
                                        </v-text-field>
                                    </label>
                                    <label for="company" class="call__label">
                                        <v-text-field
                                                v-model="company"
                                                id="company"
                                                class="call__input"
                                        >
                                            <template v-slot:label>
                                                Компания
                                            </template>
                                        </v-text-field>
                                    </label>
                                    <label for="tel" class="call__label">
                                        <v-text-field
                                                v-model="tel_input"
                                                :rules="tel_inputRulesRu"
                                                required
                                                id="tel"
                                                class="call__input"
                                                oninput="this.value = this.value.replace(/[^\d+]/g,'');"
                                        >
                                            <template v-slot:label>
                                                Телефон *
                                            </template>
                                        </v-text-field>
                                    </label>
                                    <label for="email" class="call__label">
                                        <v-text-field
                                                v-model="email"
                                                :rules="emailRulesRu"
                                                id="email"
                                                class="call__input"
                                        >
                                            <template v-slot:label>
                                                Электронная почта
                                            </template>
                                        </v-text-field>
                                    </label>

                                    <label for="message" class="call__label">
                                        <v-textarea
                                                v-model="message"
                                                id="message"
                                                class="call__input"
                                        >
                                            <template v-slot:label>
                                                Комментарий
                                            </template>
                                        </v-textarea>
                                    </label>


                                </div>
                                <!-- SmartCaptcha -->
                                <div id="captcha-container" :class="captchaPassed ? '':'error-captcha'"
                                     class="w-100"></div>

                                <div class="form_upload__item">
                                    <v-checkbox
                                            v-model="checkbox"
                                            :rules="[(v) => !!v || 'Это обязательный пункт']"
                                            required
                                            color="red"
                                    >
                                        <template v-slot:label>
                                            <div class="customLabelForm">
                                                Я выражаю согласие с <a href="javascript:void(0);" target="_blank"
                                                                        @click="$refs.modal_contents_agree.modal_open('scroll_false')">условиями
                                                использования</a> моих персональных данных для обработки данного
                                                обращения ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206,
                                                Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5,
                                                этаж 2), я ознакомлен и выражаю согласие с
                                                <a :href="policy" @click="linkOpen(policy)"
                                                   class="position-relative zi-1">Политикой конфиденциальности</a> и
                                                <a :href="agreement" @click="linkOpen(agreement)"
                                                   class="position-relative zi-1">Пользовательским соглашением.</a>
                                            </div>
                                        </template>
                                    </v-checkbox>

                                    <!--            :rules="[(v) => !!v || 'Это обязательный пункт']"-->
                                    <!--            required-->
                                    <v-checkbox
                                            v-model="consentToInform"

                                            color="red"
                                            class="mt-0"
                                    >
                                        <template v-slot:label>
                                            <div class="customLabelForm">
                                                Я выражаю согласие на информирование меня о продуктах, акциях,
                                                выгодных предложениях, новостях ООО «Компания Нова Ролл» (ИНН
                                                5038050970, адрес: 141206, Московская область, г. Пушкино,
                                                Кудринское шоссе, д. 2а, стр. 5, этаж 2) и партнеров.
                                            </div>
                                        </template>
                                    </v-checkbox>


                                </div>
                                <div class="call__box">
                                    <!--                    <p class="call__text">-->
                                    <!--                      Нажимая кнопку “Отправить”, вы соглашаетесь на обработку персональных данных.-->
                                    <!--                    </p>-->
                                    <button :disabled="!valid" class="call__btn "
                                            @click="validate">
                                        Отправить
                                    </button>
                                </div>
                            </div>
                        </section>

                    </v-form>

                </v-card-text>

            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import VModalContents from "./modal_contents";

export default {
    components: {
        VModalContents: VModalContents,
    },
    delimiters: ["${", "}"],
    props: {
        themes: Array | String | Number | Boolean | Object,
        policy: String | Boolean,
        agreement: String | Boolean,
        terms: String | Boolean,
    },
    data() {
        return {
            checkbox: false,
            consentToInform: false,

            captchaPassed: false,
            dialog: false,
            valid: true,
            name: "",
            nameRulesRu: [
                (v) => !!v || "Обязательное поле",
            ],
            email: '',
            emailRulesRu: [
                v => !v || /.+@.+\..+/.test(v) || 'Неккоректная электронная почта',
            ],
            company: '',
            tel_input: "",
            tel_inputRulesRu: [
                (v) => !!v || "Обязательное поле",
                (v) => /^((8|\+7)[- ]?)?(\(?\d{3}\)?[- ]?)?[\d\- ]{7,10}$/.test(v) || "Неккоректный телефон",
            ],


            message: "",


        };
    },
    methods: {
        linkOpen(url) {
            window.open(url, '_blank');
        },

        // Captcha
        initCaptcha() {
            window.smartCaptcha.render('captcha-container', {
                sitekey: 'ysc1_PUekBeYtvyneoIe4lOZeV4coxdETZmtFUf5aFClW81ba7cd1',
                callback: this.onCaptchaSuccess,
            });
        },
        onCaptchaSuccess(token) {
            this.captchaPassed = true;
            this.form.captchaToken = token;
        },
        // Captcha end
        validate() {
            // this.$refs.form.validate()
            if (!this.$refs.form.validate()) return false;
            if (!this.captchaPassed) {
                this.valid = false;
                return false;
            } else {
                this.valid = true;
            }
            var VueObject = this;

            let newTel = VueObject.tel_input;
            if (newTel[0] === '8') {
                newTel = newTel.slice(1); // если первая цифра 8, удаляем её
            }
            console.log(newTel);

            // перепаять - добавились поля
            $.ajax({
                "type": "POST",
                "url": "/ajax/contacts-mail.php",
                "data": {
                    "ajaxPost": "Y",
                    "name": VueObject.name,
                    "email": VueObject.email,
                    "message": VueObject.message,
                    "phone": newTel,
                    "company": VueObject.company,

                },
                "success": function (res) {
                    console.log(res);
                    VueObject.dialog = false;
                    $(".text_result_new .send__title").text("Письмо отправлено");
                    $(".text_result_new .send__subtitle").text("Мы ответим Вам в ближайшее время.");
                    $(".text_result_new").slideDown(300);
                    VueObject.reset();
                },
                "error": function (xhr, ajaxOptions, thrownError) {
                    console.log(xhr.status);
                    console.log(thrownError);
                }
            });
            // перепаять - добавились поля end
        },
        modal_open() {
            if (this.dialog) {
                this.dialog = false;
            } else {
                this.dialog = true;
                this.$nextTick(function () {
                    this.initCaptcha();
                });
            }
        },
    },
    watch: {
        captchaPassed() {
            // this.sendForm();
            if (!this.captchaPassed) {
                this.valid = false;
                return false;
            } else {
                this.valid = true;
            }
        },
    }
};
</script>

<style lang="scss">
// все стили лежат в contact_Call.vue
</style>
